import api from './api';

// Masraf projeleri (Masraf Yönetimi → Projeler). Yönetim uçları EX.Write ister; `options`
// masraf girişindeki seçici içindir (yalnız aktif projelerin adı/kodu).
export const getExpenseProjects = (params) => api.get(`/v1/expense-projects?${new URLSearchParams(params || {})}`);
export const getExpenseProjectOptions = (search) =>
  api.get('/v1/expense-projects/options', { params: search ? { search } : {} });
export const createExpenseProject = (data) => api.post('/v1/expense-projects', data);
export const updateExpenseProject = (id, data) => api.put(`/v1/expense-projects/${id}`, data);
export const deleteExpenseProject = (id) => api.delete(`/v1/expense-projects/${id}`);
export const batchDeleteExpenseProjects = (ids) => api.post('/v1/expense-projects/batch-delete', ids);
